import React, { ChangeEventHandler } from 'react';
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import uniqueId from 'lodash/uniqueId';
import { decode } from 'html-entities';
import {
    IFilterOptionData,
    IFilterOptionState,
    ITaxonomyContextValue,
} from '../../../utils/types/taxonomy';
import { isNumber } from 'lodash';
import { useRouter } from 'next/router';
import { getFilterNameBySlug } from '../../../utils/constants/taxonomy';

type Props = {
    name: string;
    options?: Array<IFilterOptionData> | null;
    disclosureProp: IFilterOptionState;
};

const FilterOptions = (props: Props) => {
    const router = useRouter();

    const { name, options, disclosureProp } = props;
    const [disclosureOpen, setDisclosureOpen, filterValue, setFilterValue] =
        disclosureProp;
    const handleOnRadioChange = (selectedFilter: IFilterOptionData) => {
        setFilterValue((prev) => {
            return selectedFilter;
        });
    };

    if (
        router.query.taxonomyFrontendSlug &&
        getFilterNameBySlug(router.query.taxonomyFrontendSlug as string) == name
    ) {
        return null;
    }

    if (typeof options === 'undefined') {
        return null;
    }

    if (options && options?.length <= 0) {
        return null;
    }

    return (
        <Disclosure defaultOpen={disclosureOpen}>
            {({ open }) => (
                <>
                    <Disclosure.Button
                        onClick={() => setDisclosureOpen((prev) => !prev)}
                        className="min-w-[290px] xl:min-w-[174px] flex items-center w-full justify-between p-2.5 text-left focus:outline-none focus-visible:ring focus-visible:ring-brand-primary-light focus-visible:ring-opacity-75 border-b border-brand-second-gray"
                    >
                        <span className="text-xs text-black">{name}</span>
                        <ChevronUpIcon
                            className={`${
                                open ? 'rotate-180 transform' : ''
                            }  h-5 w-5 text-[#3F3F46]`}
                        />
                    </Disclosure.Button>
                    <Disclosure.Panel className="text-sm text-gray-500">
                        <fieldset className="">
                            {options?.map((option, index) => {
                                const uId = uniqueId();
                                let label = option.label;
                                if (
                                    isNumber(option.count) &&
                                    option.count < 1
                                ) {
                                    return null;
                                }
                                return (
                                    <div
                                        key={index}
                                        className="p-2.5 relative flex items-start"
                                    >
                                        <div className="flex h-5 items-center" id={option.value}>
                                            <input
                                                id={uId}
                                                name={name}
                                                type="radio"
                                                value={option.value}
                                                defaultChecked={
                                                    filterValue !== null &&
                                                    typeof filterValue?.value !==
                                                        'undefined' &&
                                                    option.value ===
                                                        filterValue.value
                                                }
                                                onChange={(e) =>
                                                    handleOnRadioChange({
                                                        value: option.value,
                                                        label: label,
                                                    })
                                                }
                                                className="h-4 w-4 border-gray-300 text-brand-primary focus:ring-brand-primary cursor-pointer"
                                            />
                                        </div>
                                        <div className="ml-3 text-sm">
                                            <label
                                                htmlFor={uId}
                                                className={`font-medium text-gray-700 cursor-pointer break-all ${option.value}`}
                                            >
                                                {decode(label)}{' '}
                                                {`(${option.count})`}
                                            </label>
                                        </div>
                                    </div>
                                );
                            })}
                        </fieldset>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    );
};

export default FilterOptions;
